import cookie from "./cookie"
import jsonp, { unJsonp } from "../../assets/js/http";
import CryptoJS from 'crypto-js'

let timeInter: any
let timer: any = null

export default {
    // 对函数进行 节流
    throttle(fn: any) {
        clearTimeout(timer)
        timer = setTimeout(function () {
            fn()
        }, 200)
    },
    // 获取Url hash参数
    getQueryString(name: string) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
        let result
        let searchItem = window.location.hash.split("?")[1]
        if (searchItem !== undefined) {
            result = searchItem.match(reg)
        } else {
            searchItem = window.location.href
            result = searchItem
                .substring(searchItem.indexOf("?"), searchItem.length)
                .substr(1)
                .match(reg)
        }
        return result ? decodeURIComponent(result[2]) : null
    },
    //浏览器环境判断   是否为uzgapp
    browser() {
        let name = '', ver = '1', client, data: any = {};
        let ua = navigator.userAgent.toLowerCase();
        let ma = ua.match(/(ios|android|harmonyos)_(ule|ylxd|ylxdsq|yzgxd|yzg|yzs|ylsj)_(.[^_]*)_(.[^_]*)/)
        client = sessionStorage.getItem('xcx.type') || cookie.get('ul_sch') || cookie.get('client_type') || ''
        var xcxarr = (cookie.get('ul_xcx') || '').match(/miniwx_(.*)\|(.*)/) || ['', '_', ''];
        if (ma) {
            // 邮乐/小店/优鲜/掌柜店/邮掌柜/邮助手/邮乐商家APP
            name = ma[2]
            ver = ma[4]
        } else if (/psbc/.test(ua)) {
            // 邮储银行APP
            name = 'psbc'
        } else if (/creditcardapp/.test(ua)) {
            // 邮储信用卡APP
            name = 'psbcxyk'
        } else if (/chinapostyoushenghuo/.test(ua)) {//
            name = 'yshapp'
        } else if (/zyet|Zyet/.test(ua)) {
            name = 'zyet'
        } else {
            ma = ua.match(/micromessenger\/(.[^(]*)/)
            if (ma) {
                if (/miniprogram/.test(ua)) {
                    // 微信小程序
                    name = 'ulexcx'
                    if (xcxarr && xcxarr[1]) {
                        client = xcxarr[1]
                        if (client == 'ylxd') {
                            name = 'uxdxcx'
                        } else if (client == 'ylxdsq') {
                            name = 'usqxcx'
                        }
                    }
                    try {
                        ver = xcxarr[2] || '1'
                    } catch (error) {
                        ver = '1'
                    }
                } else {
                    // 微信
                    if (ua.match(/wxwork/i)) {
                        name = 'wxwork';
                        ver = 'wxwork'
                    } else {
                        name = 'weixin'
                        ver = 'weixin'
                    }
                }
            }
        }
        if (name) {
            data[name] = ver
        }
        return data
    },
    isWx() {
        var ua = navigator.userAgent.toLowerCase()
        var isWeixin = ua.indexOf("micromessenger") != -1
        if (isWeixin) {
            return true
        } else {
            return false
        }
    },
    getAppVersionNo() {
        return parseInt(cookie.get("appVersionNo"))
    },
    isAndroid() {
        var u = navigator.userAgent
        return u.indexOf("Android") > -1 || u.indexOf("Adr") > -1
    },
    isHmos() {
        var u = navigator.userAgent.toLowerCase()
        return u.indexOf("harmonyos") > -1
    },
    isIos() {
        var u = navigator.userAgent
        return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    },
    getZoneId() {
        let zoneId
        try {
            zoneId = cookie.get("ul_zid").split("%")[0]
        } catch (error) {
            zoneId = 934
        }
        return zoneId
    },
    getMallCookie() {
        let mall_cookie = false
        try {
            mall_cookie = cookie.get("mall_cookie") || cookie.get("ul_utk")
        } catch (error) {
        }
        if (location.hostname == "localhost") return true
        return mall_cookie
    },
    getCrmMemberInfo() {//积分商城登录cookie
        let crmMemberInfo = false
        try {
            crmMemberInfo = cookie.get("crmMemberInfo") || ''
        } catch (error) {
        }
        if (location.hostname == "localhost") return true
        return crmMemberInfo
    },
    getJsonLength(obj: any) {
        var i = 0
        for (var key in obj) i++
        return i
    },
    timeDifference(date2: any, date1: any) {
        let date3 = date1 - date2
        //计算出相差天数
        let days = Math.floor(date3 / (24 * 3600 * 1000))
        //计算出小时数
        let leave1 = date3 % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
        let hours = Math.floor(leave1 / (3600 * 1000))
        //计算相差分钟数
        let leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
        let minutes = Math.floor(leave2 / (60 * 1000))
        //计算相差秒数
        let leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
        let seconds = Math.round(leave3 / 1000)

        return {
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds
        }
    },
    toArr(item: string) {
        //分隔成数组
        if (item == "" || !item) return []
        return item.split(" ")
    },
    inArray(search: any, array: any) {
        for (var i in array) {
            if (array[i] == search) {
                return true
            }
        }
        return false
    },
    remove(arr: any, val: any) {
        //移出数组的指定项
        for (var i = 0; i < arr.length; i++) {
            if (arr[i] == val) {
                arr.splice(i, 1)
                break
            }
        }
    },
    clearIntervalFn() {
        clearInterval(timeInter)
    },
    prizereceives(m: any, params: any, fn: Function, error: any) { //抽奖 - 返回一个礼包
        m._http.sentJsonp(m,
            '//service' + m.domain + '/lottry/lottery/lottry',
            params, (res: any) => {
                fn(res.content.prizeInfos);
            }, error
        )
    },
    setTitle(title: any) {
        (window as any).dsBridge && (window as any).dsBridge.call("setNativeTitle", {
            title: title || '',
        });
    },
    isPc() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|OperaMini/i.test(navigator.userAgent) || window.screen.availWidth < 600) {
            return false
        } else {
            return true
        }
    },
    isYzs() {
        let ua = navigator.userAgent.toLowerCase()

        if (ua.indexOf("yzs") > -1 || ua.indexOf("_yzsapp_") > -1) {
            return true
        } else {
            return false
        }
    },
    // 从推荐位获取活动的code等基本信息
    /*
    ** code //主题code
    ** luckDrawCode //抽奖记录code
    ** loginCode //登陆场code
    ** orderCode //下单场code
    ** floorCode //楼层code
    ** rule //规则
    */
    getActivitySet(key: string, fn: Function, isCustomize?: boolean) {
        let url = "https://search" + process.env.VUE_APP_URI_DOMAIN + "/api/recommend?sectionKeys=" + key + '&restype=2002';
        unJsonp(url, {}).then((res: any) => {
            console.log('获取活动', res)
            // res = res.body["broadcast-Insurance"];
            // if(res[0]&&res[0].title == roomNumber){
            // 	context.commit('setInsurance',eval(JSON.parse(res[0].customAttribute).goodsList));
            // }
            let data = res && res.data[key][0];
            let obj = JSON.parse(data.customAttribute);
            if (obj.rule) {
                obj.rule = JSON.parse(obj.rule.replace(/'/g, '"')) // 单引号替换成双引号
            }
            fn(obj)
        });
        // m._http.getRemind(
        //     m,
        //     `//search${m.domain}/api/recommend`,
        //     {
        //         sectionKeys: key
        //     }, (res: any) => {
        //         let data = res && res[key][0];
        //         let obj = JSON.parse(data.customAttribute);
        //         if(obj.rule){
        //             obj.rule = JSON.parse(obj.rule.replace(/'/g, '"')) // 单引号替换成双引号
        //         }

        //         if(!isCustomize){
        //             let floorCode = obj.floorCode || obj.code || "";
        //             (window as any).uleStatUtil.sendView(location.href, {relateType: 'activity', relateId1: floorCode, relateId2: this.getZoneId(), relateId3: 1});
        //         }

        //         fn(obj)
        //     }
        // )
    },
    systemTime(fn: Function) {
        let sysTime: any = 0;
        let difference: any = 0;
        let now = new Date().getTime();
        // 如果本机时间和服务器时间差超过三分钟则获取服务器时间，否则取本机时间
        let request: any = new XMLHttpRequest();
        request.open("GET", "https://clock.ule.com/now/?_=" + new Date().getTime(), false);
        request.send();
        if (request.status === 200) {
            sysTime = request.response * 1000;
            difference = sysTime - now;
            console.log('获取当前系统时间差', difference)
            if (fn) fn(difference)
        }
    },
    multiQualification(params: any, fn: Function) {// 多活动抽奖资格查询
        let url = "https://service" + process.env.VUE_APP_URI_DOMAIN + '/appact/redenvelopes/getBatchActivityTimes';
        unJsonp(url, params).then((res: any) => {
            console.log('多活动抽奖资格查询', res)
            fn(res.data.content);
        })
        // m._http.sentJsonp(m,
        //   '//service' + m.domain + '/appact/redenvelopes/getBatchActivityTimes',
        //   params,(res: any) => {
        //     fn(res.content);
        //   }
        // )
    },
    qualification(m: any, params: any, fn: Function) {//抽奖资格查询
        let url = "https://service" + process.env.VUE_APP_URI_DOMAIN + '/appact/redenvelopes/getActivityTimes';
        unJsonp(url, params).then((res: any) => {
            console.log('抽奖资格查询', res)
            fn(res.data.content[0]);
        })
        // m._http.sentJsonp(m,
        //     '//service' + process.env.VUE_APP_URI_DOMAIN + '/appact/redenvelopes/getActivityTimes',
        //     params, (res: any) => {
        //         fn(res.content[0]);
        //     }
        // )
    },
    sendSensorTrack(action: any, roomData: any, params: any, noPrefix?: any, yshTpye?: any) {
        let ua: any = navigator.userAgent.toLowerCase()
        let isXdApp: any = /(ios|android|harmonyos)_ylxd_/.test(ua)
        let isXdShare: any = /adid=ylxdfx_merchant/.test(location.search)
        let prefix: any = ''
        if (!noPrefix) {
            prefix = (isXdApp || isXdShare) ? 'ylxd_' : 'ylw_'
        }
        let data: any = {}
        let channel: any = '其他'
        let storeId: any = (location.search.match(/(storeid|storeId)=([\d]*)/) || ['', '', ''])[2]
        if (/micromessenger/.test(ua)) {
            channel = (/miniprogram/.test(ua)) ? '小程序' : '微信'
        }

        let sysid: any = ''
        if (navigator?.userAgent.includes('SYSID')) {
            sysid = navigator.userAgent.split('SYSID/')[1]
        }
        data['sysid'] = sysid

        let yzt_bowdataId: any = ''
        if (navigator?.userAgent.includes('yzt_bowdataId')) {
            yzt_bowdataId = navigator.userAgent.split('yzt_bowdataId/')[1]
        }
        data['yzt_bowdataId'] = yzt_bowdataId

        let yzt_app_id: any = ''
        if (navigator?.userAgent.includes('APPID')) {
            yzt_app_id = navigator.userAgent.split('APPID/')[1].split(' SYSID')[0]
        }
        data['yzt_app_id'] = yzt_app_id

        let bowdataId = ''
        let urlSearchT: any = new URLSearchParams(location.search)
        if (urlSearchT.get('bowDataId')) {
            bowdataId = urlSearchT.get('bowDataId')
        }
        data['yzt_bowdataId'] = bowdataId

        data['scene_number'] = roomData.scene_number ? roomData.scene_number : ''
        // 
        if (action == 'ShareClickSuccess') {
            if (isXdShare && storeId) {
                data = {
                    ylxd_shared_identify_key: 'storeid',
                    ylxd_shared_identify_value: storeId,
                    ylxd_share_channel: channel,
                    ylxd_share_content_type: '直播间',
                    ylxd_share_content_name: roomData.title,
                    ylxd_share_content_id: (roomData.id + '')
                }
            } else {
                data = null
            }
        } else if (action == 'CouponsReceive') {
            data[prefix + 'coupon_code'] = (params.batchId + '')
            data[prefix + 'coupon_type'] = params.couponType
            data[prefix + 'coupon_name'] = params.couponName
        } else if (action == 'ItemClick') {
            data['section_id'] = '直播_商品列表'
            data['module_sort'] = params.module_sort
            data['item_id'] = (params.listId + '')
            data['is_recommendation'] = false
            data[prefix + 'item_name'] = params.listName
            data[prefix + 'commodity_current_price'] = params.minPrice
            data[prefix + 'current_page_type'] = '直播间'
            data[prefix + 'current_page_name'] = roomData.title
            data[prefix + 'page_area'] = '直播商品'
            data[prefix + 'live_id'] = (roomData.id + '')
            data[prefix + 'live_name'] = roomData.title
            data[prefix + 'live_type'] = (roomData.scene_type == 2) ? '录播' : '直播'
            data[prefix + 'live_commodity_rank'] = params.module_sort
        } else if (action == 'btnClick' || yshTpye == 'yshPoint') {
            data = params
            data[prefix + 'button_name'] = params.button_name
            data[prefix + 'live_id'] = (roomData.id + '')
            data[prefix + 'live_name'] = roomData.title
            data[prefix + 'live_type'] = (roomData.scene_type == 2) ? '录播' : '直播'
            if (yshTpye == 'yshPoint') {
                let ysh_application_name = ''
                let ysh_platform_type = ''
                let crm_id: any = ''
                // let sysid: any = ''
                let sceneNum: any = roomData.scene_number
                let urlSearch: any = new URLSearchParams(location.search)
                if (urlSearch.get('crm_id')) {
                    crm_id = urlSearch.get('crm_id')
                }
                if ((urlSearch.get('adid') != null && (urlSearch.get('adid')).indexOf('ysh') > -1) || (cookie.load().ul_union?.includes('1016039307'))) {
                    ysh_application_name = '邮生活'
                    if (cookie.load()['user-agent']?.includes('miniprogram')) { //  小程序环境
                        ysh_platform_type = 'ysh_小程序'
                    } else if (cookie.load()['user-agent']?.includes('micromessenger')) { //  h5环境
                        ysh_platform_type = 'ysh_H5'
                    } else {
                        ysh_platform_type = 'ysh_app'
                    }
                }
                if (navigator?.userAgent.includes('ChinaPostOMP')) {
                    ysh_application_name = '一账通'
                }

                // if (navigator?.userAgent.includes('SYSID')) {
                //     sysid = navigator.userAgent.split('SYSID/')[1]
                // }
                data[prefix + 'application_name'] = ysh_application_name
                data[prefix + 'platform_type'] = ysh_platform_type
                data[prefix + 'crm_id'] = crm_id
                data[prefix + 'sceneNum'] = sceneNum
                // if (sysid) data[prefix + 'sysid'] = sysid
            }
        } else {
            data[prefix + 'live_id'] = (roomData.id + '')
            data[prefix + 'live_name'] = roomData.title
            data[prefix + 'live_type'] = (roomData.scene_type == 2) ? '录播' : '直播'
            console.log(data)
        }
        if ((window as any).uleStatUtil && data) {
            (window as any).uleStatUtil.sendSensorTrack(prefix + action, data)
        }
    },
    getPosition (query: any,next: any) {
        let cookiesPos:any = "";
        let domain:any = process.env.VUE_APP_URI_DOMAIN     
        if (location.hostname == 'localhost') {
            domain = ''
        }   
        let getAdcodeData = {
            key: "OTHBZ-3VGKV-UU4P3-ULQNZ-7DPSS-KOFT4",
            callbackName: "QQmap",
            output: "jsonp",
            location: "",
            get_poi: 1,
            jsonp: "callback"
        };                
        if (this.browser().usqxcx) {
            // 地址上带有参数
            if (query.adcode && query.lat&&query.lat!='undefined' && query.lng && query.lng!='undefined') {
                cookiesPos = {
                    location:`${query.lat},${query.lng}`,
                    adcode: query.adcode,
                }
                document.cookie = `location=${JSON.stringify(cookiesPos)};domain=${domain};path=/;`;
            } else if (query.latng && query.module) {
                console.log("应该走这里的");
                getAdcodeData.location = query.latng;
                unJsonp("//apis.map.qq.com/ws/geocoder/v1", getAdcodeData).then((qq: any) => {
                    let res = qq.body;
                    cookiesPos = {
                        location: query.latng,
                        adcode: res.result.ad_info.adcode,
                    };
                    document.cookie = `location=${JSON.stringify(cookiesPos)};domain=${domain};path=/;`;
                    next && next();
                })
            }          
        } else if (this.browser().weixin) {
            console.log("当前是微信环境");
            // 地址上带有参数
            if (query.adcode && query.lat && query.lng) {
                cookiesPos = {
                    location:`${query.lat},${query.lng}`,
                    adcode: query.adcode,
                }
                document.cookie = `location=${JSON.stringify(cookiesPos)};domain=${domain};path=/;`;
            } else if (query.latng && query.module) {
                console.log("应该走这里的");
                getAdcodeData.location = query.latng;
                unJsonp("//apis.map.qq.com/ws/geocoder/v1", getAdcodeData).then((qq: any) => {
                    let res = qq.body;
                    cookiesPos = {
                        location: query.latng,
                        adcode: res.result.ad_info.adcode,
                    };
                    document.cookie = `location=${JSON.stringify(cookiesPos)};domain=${domain};path=/;`;
                    next && next();
                })
            } else {// 无参数
                let appid = "";
                if (process.env.NODE_ENV === "beta") {
                    appid = "wx8b73da0067c52318";
                } else if (process.env.NODE_ENV === "testing") {
                    appid = "wx4e190edda7e57237";
                } else if (process.env.NODE_ENV === "production") {
                    appid = "wx4e190edda7e57237";
                }
                var data = {
                    appId: appid,
                    appkey: "4b9f40822ddd5cd5",
                    version_no: "apr_2010_build01",
                    lotteryInfoId: "325",
                    currentPageUrl: location.href,
                    jsonp: 'jsonApiCallback'
                };  
                console.log("appid========", appid);
                console.log("data============", data);      
                unJsonp(`//service${process.env.VUE_APP_URI_DOMAIN}/api/mobile/getWechatSignature.do`, data).then((sign: any) => {                   
                    if (sign.body.returnCode == "0000") {
                        (window as any).wx.config({
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: appid, // 必填，公众号的唯一标识
                            timestamp: sign.body.detail[0].timestamp, // 必填，生成签名的时间戳
                            nonceStr: sign.body.detail[0].nonceStr, // 必填，生成签名的随机串
                            signature: sign.body.detail[0].signature, // 必填，签名
                            jsApiList: ["getLocation", "openLocation"], // 必填，需要使用的JS接口列表
                        });
                        (window as any).wx.ready(function() {
                            (window as any).wx.getLocation({
                                type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                                success: function(res:any) {
                                    console.log("res=============", res);
                                    let latitude = Number(res.latitude.toString().match(/^\d+(?:\.\d{0,5})?/));
                                    let longitude = Number(res.longitude.toString().match(/^\d+(?:\.\d{0,5})?/));
                                    console.log("latitude====", latitude);
                                    console.log("longitude====", longitude);
                                    let location = `${latitude},${longitude}`;
                                    getAdcodeData.location = location;
                                    console.log("getAdcodeData===", getAdcodeData);
                                    unJsonp("//apis.map.qq.com/ws/geocoder/v1", getAdcodeData).then((qq: any) => {
                                        cookiesPos = {
                                            location: location,
                                            adcode: qq.body.result.ad_info.adcode,
                                        };
                                        document.cookie = `location=${JSON.stringify(cookiesPos)};domain=${domain};path=/;`;
                                        next && next();
                                    })
                                },
                                fail: function(err:any) {
                                    console.log("err", err);
                                },
                                cancel: function(cal:any) {
                                    console.log("cal=====", cal);
                                },
                            });
                        });
                    } else {
                        // Toast("无法获取位置，请手动定位");
                    }
                });
            }
        }  // 优鲜app、邮乐app、邮乐小店app
        else if (this.browser().ylxdsq || this.browser().ule || this.browser().ylxd || (window as any).ulemax) {
            (window as any).dsBridge.register("getCurrentCityCode", (e:any) => {
                e = JSON.parse(e);
                console.log('app方法获取的定位',e)
                let currentAdcode = e.cityCode;
                next && next(e);
            });
            (window as any).dsBridge.call("getCurrentCityCode", { ios_action: "getCurrentCityCode", android_action: "getCurrentCityCode", minversion: "207", maxversion: "999" });
        } else {
            // 地址上带有参数
            if (query.adcode && query.lat && query.lng) {
                cookiesPos = {
                    location:`${query.lat},${query.lng}`,
                    adcode: query.adcode,
                }
                document.cookie = `location=${JSON.stringify(cookiesPos)};domain=${domain};path=/;`;
            } else if (query.latng && query.module) {
                console.log("应该走这里的");
                getAdcodeData.location = query.latng;
                unJsonp("//apis.map.qq.com/ws/geocoder/v1", getAdcodeData).then((qq: any) => {
                    let res = qq.body;
                    cookiesPos = {
                        location: query.latng,
                        adcode: res.result.ad_info.adcode,
                    };
                    document.cookie = `location=${JSON.stringify(cookiesPos)};domain=${domain};path=/;`;
                    next && next();
                })
            }            
        }
    },
    // 加密
    encrypted (str: any) {
        var key = CryptoJS.enc.Latin1.parse('aZcdule123456782');
        var iv = CryptoJS.enc.Latin1.parse('0z234567ulebcde7');
        var encrypted = CryptoJS.AES.encrypt(str, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding
        });
        return encrypted.toString() || str;
    },
}
